import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import api from "@/lib/api";
import DepotLists from "@/components/documentdepot/DepotLists";

export default function StudentDocumentDepot() {
  const { studentId } = useOutletContext();
  const [data, setData] = useState({ forms: [], handouts: [] });

  useEffect(() => {
    api.get(`/parent/students/${studentId}/document-depot`)
      .then(({ data }) => setData({ forms: data.forms || [], handouts: data.handouts || [] }))
      .catch(() => {});
  }, [studentId]);

  return <DepotLists forms={data.forms} handouts={data.handouts} readOnly />;
}
